import React, { useState } from "react";
import ModalCard from "../../../components/ModalCard";
import ModalCardWithHeaderFooter from "../../../components/Cards/ModalCardWithHeaderFooter";
import Card1 from "./BulkApprove/Card1";
import Card2 from "./BulkApprove/Card2";
import Card3 from "./BulkApprove/Card3";
import { bulkApproveOrderAPI } from "../../../service/api_calls/orders/OrdersApi";
import {
  handleRefreshTabData,
  refreshPendingOrderData,
} from "../../../reducers/orders/ordersSlice";
import { useDispatch } from "react-redux";

function BulkApproveContent({ modal, setModal, data }) {
  const [activeCard, setActiveCard] = useState(1);
  const [loader, setLoader] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = () => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    if (activeCard == 1) bulkApproval();
    if (activeCard == 2) setActiveCard(3);
    if (activeCard == 3) {
      setModal(false);
      dispatch(handleRefreshTabData());
      dispatch(
        refreshPendingOrderData({
          businessId,
          pageSize: 25,
          pageNo: 1,
        })
      );
    }
  };

  const getSubmitText = () => {
    if (activeCard == 1) return "Approve All";
    if (activeCard == 2) return "Next";
    if (activeCard == 3) return "OK";
  };

  const bulkApproval = async () => {
    const businessId = sessionStorage.getItem("selectedBusinessId");

    setLoader(true);

    const payloadData = data.map(({ cartId, orderId }) => ({
      cartId,
      orderId,
      businessId, // Add businessId here
    }));

    const res = await bulkApproveOrderAPI({ businessId, data: payloadData });

    setTimeout(() => {
      console.log("payloadDatapayloadData", payloadData);
      setLoader(false);
      setActiveCard(3);
    }, 5000);
  };
  return (
    <ModalCard
      open={modal}
      handleClose={() => setModal(null)}
      width={data?.length > 8 ? "50%" : "40%"}
    >
      <ModalCardWithHeaderFooter
        title="Order Approval"
        footerJC="center"
        submitText={getSubmitText()}
        hideCancel={activeCard == 2 || activeCard == 3}
        onCancel={() => setModal(false)}
        onSubmit={onSubmit}
        loader={loader}
      >
        {activeCard == 1 && <Card1 data={data} />}
        {/* {activeCard == 2 && <Card2 data={data} />} */}
        {activeCard == 3 && <Card3 data={data} />}
      </ModalCardWithHeaderFooter>
    </ModalCard>
  );
}

export default BulkApproveContent;
